import { resizeGame } from '@pascal/pascal-core';

const maxHeight = 700;
const maxWidth = 1196;
const target = document.querySelector('#root');
export const resizeGameHandler = () => {
  resizeGame(maxHeight, maxWidth, target);
};
